import { render, staticRenderFns } from "./EventsCalendar.vue?vue&type=template&id=a0530164&scoped=true"
import script from "./EventsCalendar.vue?vue&type=script&lang=js"
export * from "./EventsCalendar.vue?vue&type=script&lang=js"
import style0 from "./EventsCalendar.vue?vue&type=style&index=0&id=a0530164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0530164",
  null
  
)

export default component.exports